import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Refresh from '@material-ui/icons/Refresh';
import ResetChangePassDialog from '../molecules/ResetChangePassDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(withState('openDelete', 'setOpenDelete', false));

const button = enhance(
  ({ classes, openDelete, setOpenDelete, params, onClickAction }) => {
    const cancelAction = () => setOpenDelete(false);
    return (
      <div>
        <Button
          color="primary"
          onClick={() => {
            setOpenDelete(true);
          }}
        >
          <Refresh className={classes.leftIcon} />
          パスワードリセット
        </Button>
        <ResetChangePassDialog
          params={params}
          openDelete={openDelete}
          updateOpenDelete={setOpenDelete}
          cancelAction={cancelAction}
          onClickAction={onClickAction}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
